if (!customElements.get('reference-expertise')) {
  customElements.define('reference-expertise', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      if (this.dataset.motion === 'true' && !matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
        this.classList.add('is-pending');
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) { this.classList.remove('is-pending'); this.observer.disconnect(); }
        }, {threshold: .1});
        this.observer.observe(this);
      }
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.player = this.querySelector('[data-expertise-player]');
      this.template = this.querySelector('[data-expertise-video-template]');
      this.querySelectorAll('[data-expertise-open]').forEach(link => link.addEventListener('click', event => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        if (this.dialog.open) return;
        this.trigger = link;
        this.player.replaceChildren(this.template.content.cloneNode(true));
        this.dialog.showModal();
        this.previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        this.ownsScrollLock = true;
      }, {signal}));
      this.querySelector('[data-expertise-close]').addEventListener('click', () => this.dialog.close(), {signal});
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, {signal});
      this.dialog.addEventListener('close', () => this.cleanupPlayer(true), {signal});
      this.addEventListener('shopify:section:select', () => this.classList.remove('is-pending'), {signal});
    }
    cleanupPlayer(restoreFocus = false) {
      this.player?.querySelectorAll('video').forEach(video => video.pause());
      this.player?.replaceChildren();
      if (this.ownsScrollLock) {
        if (document.body.style.overflow === 'hidden') document.body.style.overflow = this.previousOverflow;
        this.ownsScrollLock = false;
      }
      if (restoreFocus && this.trigger?.isConnected) this.trigger.focus();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.classList.remove('is-pending');
      this.cleanupPlayer();
      if (this.dialog?.open) this.dialog.close();
      this.controller?.abort();
      this.controller = null;
    }
  });
}
